module.exports = __webpack_public_path__ + "img/shape_rectangle.0659ace.png";